import React from 'react';
import ReactDOM from 'react-dom';

import {
  Row,
  Col,
  Icon,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  FormControl,
  PanelContainer,
  FormGroup,
  ControlLabel,
  Form,
  Well,
  InputGroup,
  Button,
  ButtonGroup,
  ButtonToolbar,
} from '@sketchpixy/rubix';

import {
  getRapaelClients,
  deleteRapaelClient,
  getAccessToken,
  inactivateRapaelClient,
  activateRapaelClient,
} from '../../api/api';
import { downloadRapaelClient } from '../../api/url';
import ServiceType from '../../constants/ServiceType';
import { routeUrl } from '../routeUrl';


import ApkEditModal from './components/ApkEditModal';
import UploadRapaelClientModal from './components/UploadRapaelClientModal';

export default class ReleaseMgnt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showApkEditModal: false,
      showUploadModal: false,
      rapaelClientId: null,
    };
  }

  listTable = null;

  componentDidMount() {
  }

  doSearch = (search) => {
    this.listTable.doSearch(search);
  }

  addRapaelClient = () => {
    this.setState({
      showApkEditModal: true,
      rapaelClientId: null,
    });
  }

  detailRapaelClient = (rapaelClientId) => {
    this.props.router.push(`${routeUrl.releaseDetail}/${rapaelClientId}`);
  }

  editRapaelClient = (rapaelClientId) => {
    this.setState({
      showApkEditModal: true,
      rapaelClientId: rapaelClientId,
    });
  }


  closeApkEditModal = () => {
    this.setState({
      showApkEditModal: false,
    });
  }


  uploadRapaelClient = () => {
    this.setState({
      showUploadModal: true,
    });
  }

  closeUploadModal = () => {
    this.setState({
      showUploadModal: false,
    });
  }


  render() {
    return (
      <Grid>
        <Row>
          <Col sm={12}>
            <PanelContainer controls={false}>
              <Panel>
                <PanelHeader className="bg-pinkishred fg-white">
                  <Grid>
                    <Row>
                      <Col xs={12}>
                        <h3>
                          Release Management
                        </h3>
                      </Col>
                    </Row>
                  </Grid>
                </PanelHeader>
                <PanelBody style={{ padding: 25 }}>
                  <Grid>
                    <Row>
                      <Col xs={12}>
                        <ReleaseSearchForm doSearch={this.doSearch} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} className="text-right">
                        <ButtonToolbar className="inbox-toolbar">
                          <ButtonGroup>
                            <Button bsStyle="info" onClick={this.addRapaelClient}>
                              <Icon glyph="icon-fontello-doc-new" />
                            </Button>
                            <Button bsStyle="info" onClick={this.uploadRapaelClient}>
                              <Icon glyph="icon-fontello-upload" />
                            </Button>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <ReleaseListTable
                          ref={(ref) => this.listTable = ref}
                          editRapaelClient={this.editRapaelClient}
                          detailRapaelClient={this.detailRapaelClient}
                        />
                        <br />
                      </Col>
                    </Row>
                  </Grid>
                </PanelBody>
              </Panel>
            </PanelContainer>
          </Col>
        </Row>
        <ApkEditModal
          showModal={this.state.showApkEditModal}
          closeModal={this.closeApkEditModal}
          rapaelClientId={this.state.rapaelClientId}
        />
        <UploadRapaelClientModal
          showModal={this.state.showUploadModal}
          closeModal={this.closeUploadModal}
        />
      </Grid>
    );
  }
}

class ReleaseSearchForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: {
        status: '',
        serviceType: '',
      },
    };


    this.doSearch = this.doSearch.bind(this);
  }

  serviceTypeChangeHandler = (event) => {
    var search = { ...this.state.search }
    search.serviceType = event.target.value;
    this.setState({
      search: search,
    }, () => {
    });

  }

  rapaelClientActivationChangeHandler = (event) => {
    var search = { ...this.state.search }
    search.rapaelClientActivation = event.target.value;
    this.setState({
      search: search,
    }, () => {
    });

  }

  doSearch(event) {
    event.preventDefault();
    this.props.doSearch(this.state.search);
  }

  componentDidMount() {

  }

  render() {
    return (
      <Well>
        <Form horizontal onSubmit={this.doSearch}>
          <FormGroup controlId="serviceTypeSelect">
            <Col componentClass={ControlLabel} sm={2}>Service Type</Col>
            <Col sm={10}>
              <FormControl
                componentClass="select"
                onChange={this.serviceTypeChangeHandler}
                value={this.state.search.serviceType}
              >
                <option value="">ALL</option>
                {
                  ServiceType.enumValues.map(serviveType => (
                    <option key={serviveType.name} value={serviveType.name}>{serviveType.title}</option>
                  ))
                }
              </FormControl>
            </Col>
          </FormGroup>
          <FormGroup controlId="searchWord">
            <Col sm={2} componentClass={ControlLabel}>Status</Col>
            <Col sm={10}>
              <InputGroup>
                <FormControl
                  componentClass="select"
                  onChange={this.rapaelClientActivationChangeHandler}
                  value={this.state.search.rapaelClientActivation}
                >
                  <option value="">All</option>
                  <option key="Y" value="1">ACTIVE</option>
                  <option key="N" value="0">INACTIVE</option>
                </FormControl>
                <InputGroup.Button>
                  <Button onClick={this.doSearch}>Search</Button>
                </InputGroup.Button>
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>
      </Well>
    );
  }
}

class ReleaseListTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: true,
      search: {},
      datatables: null,
    };
    this.editRapaelClient = this.editRapaelClient.bind(this);
  }

  editRapaelClient = (rapaelClientId) => {
    this.props.editRapaelClient(rapaelClientId);
  }

  detailRapaelClient = (rapaelClientId) => {
    this.props.detailRapaelClient(rapaelClientId);
  }

  deleteRapaelClient = (rapaelClientId) => {
    let self = this;
    vex.dialog.confirm({
      message: 'Are you sure to delete this item?',
      callback: function (value) {
        if (value) {
          deleteRapaelClient(rapaelClientId, (err) => {
            if (err) {
              vex.dialog.alert('Failed to delete release!');
            } else {
              vex.dialog.alert('Release Deleted!');
              self.doSearch();
            }
          });
        } else {
          console.log('delete cancel')
        }
      },
    });
  }

  activateRapaelClient = (rapaelClientId) => {
    let self = this;
    vex.dialog.confirm({
      message: 'Are you sure to activate this item?',
      callback: function (value) {
        if (value) {
          activateRapaelClient(rapaelClientId, (err) => {
            if (err) {
              vex.dialog.alert('Failed to activate release!');
            } else {
              vex.dialog.alert('Activated!');
              self.doSearch();
            }
          });
        } else {
          console.log('activate cancel')
        }
      },
    });
  }

  inactivateRapaelClient = (rapaelClientId) => {
    let self = this;
    vex.dialog.confirm({
      message: 'Are you sure to inactive this item?',
      callback: function (value) {
        if (value) {
          inactivateRapaelClient(rapaelClientId, (err) => {
            if (err) {
              vex.dialog.alert('Failed to inactive release!');
            } else {
              vex.dialog.alert('Inactivated !');
              self.doSearch();
            }
          });
        } else {
          console.log('inactive  cancel')
        }
      },
    });
  }

  downloadRapaelClient = (rapaelClientId) => {
    let accessToken = getAccessToken();
    document.location.href = `${downloadRapaelClient}/${rapaelClientId}?access_token=${accessToken}`
  }

  gotoAssetUpload = (serviceTypeName, versionCode) => {
    document.location.href = `/asset/upload/${serviceTypeName}/${versionCode}`
  }


  componentDidMount() {
    let self = this;
    let datatableDom = $(ReactDOM.findDOMNode(this.refs.datatables));
    let datatables = datatableDom.addClass('nowrap')
      .DataTable({
        language: { infoFiltered: "" },
        processing: true,
        serverSide: true,
        responsive: true,
        searchDelay: 2000,
        searching: false,
        ajax: function (data, callback) {
          let search = self.state.search;
          let param = _.merge({}, data, search)

          getRapaelClients(param, (err, res) => {
            callback(res.result);
          });
        },
        columns: [
          {
            name: 'serviceTypeName',
            data: 'serviceTypeName',
            defaultContent: "",
          },
          {
            name: 'versionCode',
            data: 'versionCode',
            defaultContent: "",
          },
          {
            name: 'rapaelClientActivation',
            data: 'rapaelClientActivation',
            defaultContent: "",
            render: function (d) {
              return d === 0 ? 'N' : 'Y';
            },
          },
          {
            name: 'adminUserName',
            data: 'adminUserDto.adminUserName',
            defaultContent: "",
          },
          {
            name: 'updatedTime',
            data: 'updatedTime',
            defaultContent: "",
            render: function (d) {
              return moment(d).format('MMMM Do YYYY, h:mm:ss a')
            },
          },
          {
            name: 'actions',
            data: 'rapaelClientId',
            defaultContent: "",
            render: function (rapaelClientId, type, row) {
              let buttons = '';

              if (row.rapaelClientActivation === 1) {
                buttons += "<Button class='btn btn-success active_rapael_client_btn' data-id='" + rapaelClientId + "' data-action='INACTIVE'>Inactive</Button>" //활성화
              } else if (row.rapaelClientActivation === 0) {
                buttons += "<Button class='btn btn-success active_rapael_client_btn' data-id='" + rapaelClientId + "' data-action='ACTIVE'>Active</Button>" //활성화
              }
              buttons += "<Button class='btn btn-info edit_rapael_client_btn'  data-id='" + rapaelClientId + "' data-action='EDIT'>Edit</Button>"; //수정
              buttons += "<Button class='btn btn-danger delete_rapael_client_btn' data-id='" + rapaelClientId + "' data-action='DELETE'>Delete</Button>" //Delete
              buttons += "<Button class='btn secondary delete_rapael_client_btn' data-id='" + rapaelClientId + "' data-action='DETAIL'>Detail</Button>" //Detail
              buttons += "<Button class='btn btn-warning asset_rapael_client_btn' data-id='" + rapaelClientId + "' data-service-type='" + row.serviceTypeName + "' data-version-code='" + row.versionCode + "' data-action='ASSET'>Asset</Button>" //Asset Link
              buttons += "<Button class='btn btn-success download_rapael_client_btn' data-id='" + rapaelClientId + "' data-action='DOWNLOAD'>Download</Button>" //Download

              return buttons;
            },
          },
        ],
        rowId: 'rapaelClientId',
        select: true,
      });

    datatableDom.find('tbody').on('click', 'button', function (event) {
      let rapaelClientId = $(event.target).data("id");
      let action = $(event.target).data("action");
      switch (action) {
        case 'EDIT':
          self.editRapaelClient(rapaelClientId);
          break;
        case 'DELETE':
          self.deleteRapaelClient(rapaelClientId);
          break;
        case 'DETAIL':
          self.detailRapaelClient(rapaelClientId);
          break;
        case 'ACTIVE':
          self.activateRapaelClient(rapaelClientId);
          break;
        case 'INACTIVE':
          self.inactivateRapaelClient(rapaelClientId);
          break;
        case 'ASSET':
          let serviceTypeName = $(event.target).data("service-type");
          let versionCode = $(event.target).data("version-code");
          self.gotoAssetUpload(serviceTypeName, versionCode);
          break;
        case 'DOWNLOAD':
          self.downloadRapaelClient(rapaelClientId);
          break;
      }
    });

    this.setState({ datatables: datatables });
  }

  doSearch = (search) => {
    this.setState({ search: search }, () => {
      this.state.datatables.ajax.reload();
    });
  }


  render() {
    return (
      <Table ref="datatables" className="display" cellSpacing="0" width="100%">
        <thead>
        <tr>
          <th>Service Type</th>
          <th>Version Code</th>
          <th>Active</th>
          <th>Writer</th>
          <th>Modified Date</th>
          <th>Actions</th>
        </tr>
        </thead>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/ReleaseMgnt/ReleaseMgnt.js